import { store } from "@indieasy.software/indieasy-engine";

import * as reducers from "./reducers";

export const addReducers = () => {
  Object.keys(reducers).forEach((key) => {
    store.addReducer(key, reducers[key]);
  });
};
